import { create } from 'zustand';
import { createRef } from 'react';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import { subscribeWithSelector } from 'zustand/middleware';

const initialState = {
  isSet: false,
  isWaiting: false,
  suggestSearches: 0,
  isFinished: false,
  fieldTitle: true,
  fieldArtist: true,
  totalCount: 0,
  currentPage: 1,
  tracks: null,
  itemsSuggested: null,
  searchQuery: "",
  searchNavBarInputRef: createRef(),
  latestReqId: -1,
  latestSuggestReqId: -1,
  isWaitingSuggested: false,
  isArtistSearchMode: false
};

const searchStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {

    set(initialState);
  },
  setResetArtistSearchMode: () => {
    set({isArtistSearchMode: false, fieldArtist: true, fieldTitle: true});
  },
  setSearchNavBarInputRef: (ref) => {


    set({ searchNavBarInputRef: ref });
  },
  setSearchQuery: (searchQuery) => {


    set({ searchQuery: searchQuery });
  },
  setOnlyArtist: () => {
    set({
      fieldTitle: false,
      fieldArtist: true,
      isArtistSearchMode: true
    });
  },
  clearFilters: () => {
    console.log("search filters");
    set({
      fieldTitle: true,
      fieldArtist: true,
    });
  },
  clearSearch: () => {

    set({
      fieldTitle: true,
      fieldArtist: true,
      totalCount: 0,
      currentPage: 1,
      tracks: null,
      searchQuery: "",
      isWaitingSuggested: false,
    });
  },
  search: (sessionToken, pageSize) => {
    console.log("search", get().fieldTitle, get().fieldArtist);
    set({ currentPage: 1, isWaiting: true, isFinished: false, tracks: null });
    MuvikaService.search(sessionToken, pageSize, 1, get().searchQuery, get().fieldTitle, get().fieldArtist)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let latestReqId = get().latestReqId;
          let newReqId = res.data.request_id;
          console.log("search reqId", latestReqId, newReqId)
          let tracksList = res.data.data.items;
          if (newReqId > latestReqId) {
            set({ isSet: true, tracks: tracksList, totalCount: res.data.data.items_total, isWaiting: false, latestReqId: newReqId });
            if (tracksList.length < pageSize) {
              set({ isFinished: true });
            }
          }
        }
      })
      .catch(function () { });
  },
  searchMore: (sessionToken, pageSize) => {
    if (!get().isWaiting) {
      let page = get().currentPage + 1;
      set({ currentPage: page, isWaiting: true });
      MuvikaService.search(sessionToken, pageSize, page, get().searchQuery, get().fieldTitle, get().fieldArtist, get().fieldKcode)
        .then(function (res) {
          if (res.data.error) {
            set({ isSet: false, isWaiting: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let latestReqId = get().latestReqId;
            let newReqId = res.data.request_id;
            let tracks = get().tracks;
            let tracksMore = res.data.data.items;
            if (newReqId > latestReqId) {
              if (tracksMore.length == 0) {
                set({ isFinished: true });
              }
              tracks = tracks.concat(tracksMore);
              set({ isSet: true, tracks: tracks, totalCount: res.data.data.items_total, isWaiting: false, latestReqId: newReqId });
            }
          }
        })
        .catch(function () { });
    }
  },
  searchSuggest: (sessionToken, query, isNavBar = false, timeoutId = null) => {
    console.log("musicSearch");
    set({ currentPage: 1, isFinished: false, isWaitingSuggested: true });
    console.log("musicSearch", get().suggestSearches);
    MuvikaService.searchSuggest(sessionToken, query, isNavBar ? true : get().fieldTitle, isNavBar ? true : get().fieldArtist)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, isWaitingSuggested: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let latestSuggestReqId = get().latestSuggestReqId;
          let newReqId = res.data.request_id;
          let itemsList = res.data.data.items;
          if (newReqId > latestSuggestReqId) {
            if (itemsList.length > 0) {
              itemsList.id = timeoutId;
              set({ itemsSuggested: itemsList });
            }
            console.log("musicSearch", get().suggestSearches);
            set({ isSet: true, isWaitingSuggested: false, latestSuggestReqId: newReqId, isFinished: true });
          }
        }
      })
      .catch(function () { });
  },
  toggleFieldTitle: () => {

    set({ fieldTitle: !get().fieldTitle });
  },
  toggleFieldArtist: () => {

    set({ fieldArtist: !get().fieldArtist });
  },
})));

export default searchStore;
